import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  manageOrgInvitation,
  ManageOrgInvitationInput,
} from '@/features/org/api/manage-org-invitation';

type Props = Omit<
  UseMutationOptions<
    Awaited<ReturnType<typeof manageOrgInvitation>>,
    unknown,
    ManageOrgInvitationInput
  >,
  'mutationFn'
>;

export const useManageOrgInvitationMutation = ({ ...props }: Props) => {
  return useMutation({
    ...props,
    mutationFn: async (data) => {
      const { invitationToken, status } = data;
      return await manageOrgInvitation({ invitationToken, status });
    },
  });
};
